/**
 * Wires the shared slash menu renderer into bundled NotionEditor builds.
 * register-CIEWWZTH.js delegates to these hooks when present.
 */
import {
  isEmptyLineSlashAllowed,
  renderSlashMenuItems,
  shouldResetSlashDismissed,
} from "@components/TiptapEditor/slashCommandItems.js";
import { createSlashDismissSyncPlugin } from "@components/TiptapEditor/slashDismissSync.js";

if (typeof window !== "undefined") {
  if (!window.__exiqNotionEditorSlashPatchInitialized) {
    window.__exiqRenderSlashMenuItems = renderSlashMenuItems;
    window.__exiqIsEmptyLineSlashAllowed = isEmptyLineSlashAllowed;
    window.__exiqCreateSlashDismissSyncPlugin = createSlashDismissSyncPlugin;
    window.__exiqShouldResetSlashDismissed = shouldResetSlashDismissed;
    window.__exiqNotionEditorSlashPatchInitialized = true;
  }
}
